import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Badge,
  Button,
  Alert,
  Container,
  Spinner,
  Table
} from 'reactstrap';
import { MapPin, Package, Truck, CheckCircle, AlertCircle, ArrowLeft } from 'react-feather';
import { baseURL, getPublicS3Url } from '../../../../Services/api/baseURL';
import axios from 'axios';
import moment from 'moment';

const SubOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  console.log(id, "orderId")
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = JSON.parse(localStorage.getItem("token"));

  console.log(order, "order details")

  const getBadgeColor = (status, type) => {
    if (type === 'payment') {
      return {
        pending: 'danger',
        failed: 'danger',
        completed: 'success',
        success: 'success',
      }[status] || 'secondary';
    }
    if (type === 'order') {
      return {
        Pending: 'warning',
        Confirmed: 'info',
        Delivered: 'success',
        Cancelled: 'danger',
      }[status] || 'secondary';
    }
    return 'secondary';
  };

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseURL}/api/order/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log(response?.data, "full response");
        
        // The API returns order data directly or wrapped in 'order' key
        const orderData = response?.data?.order || response?.data?.data || response?.data;
        setOrder(orderData);
      } catch (err) {
        console.error('Error:', err);
        setError(err.response?.data?.message || 'Failed to fetch order details');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchOrder();
    }
  }, [id]);

  if (loading) {
    return (
      <Container fluid className="p-4">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <Spinner color="primary" />
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="p-4">
        <Alert color="danger">
          <AlertCircle size={16} className="me-2" />
          {error}
        </Alert>
        <Button color="primary" onClick={() => navigate('/orders')}>
          <ArrowLeft size={16} className="me-2" />
          Back to Orders
        </Button>
      </Container>
    );
  }

  return (
    <Container fluid className="p-4">
      {/* Header Section */}
      <Row className="mb-4">
        <Col className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <Button color="light" size="sm" onClick={() => navigate('/orders')}>
              <ArrowLeft size={16} />
            </Button>
            <div>
              <h4 className="mb-0">Order Details</h4>
              <small className="text-muted">Order ID: {order?._id}</small>
            </div>
          </div>
          <Badge color={getBadgeColor(order?.status, 'order')} style={{ fontSize: '14px', padding: '8px 16px' }}>
            {order?.status?.toUpperCase()}
          </Badge>
        </Col>
      </Row>

      <Row>
        {/* Customer Information */}
        <Col lg={6} className="mb-4">
          <Card>
            <CardHeader>
              <h5 className="mb-0">Customer Information</h5>
            </CardHeader>
            <CardBody>
              {typeof order?.user === 'string' ? (
                <Alert color="warning" className="mb-0">
                  User ID: {order?.user}
                  <br />
                  <small>Full user details not available in this order</small>
                </Alert>
              ) : (
                <>
                  <div className="mb-3">
                    <strong>Name:</strong>
                    <p className="mb-1">{order?.user?.name || 'N/A'}</p>
                  </div>
                  <div className="mb-3">
                    <strong>Phone:</strong>
                    <p className="mb-1">{order?.user?.phone || 'N/A'}</p>
                  </div>
                  <div className="mb-3">
                    <strong>Email:</strong>
                    <p className="mb-0">{order?.user?.email || 'N/A'}</p>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>

        {/* Delivery Address */}
        <Col lg={6} className="mb-4">
          <Card>
            <CardHeader>
              <h5 className="mb-0">Delivery Address</h5>
            </CardHeader>
            <CardBody>
              <div className="d-flex align-items-start">
                <MapPin size={20} className="me-2 mt-1 text-primary" />
                <div>
                  {order?.address?.address ? (
                    <p className="mb-0">{order?.address?.address}</p>
                  ) : (
                    <Alert color="warning" className="mb-0">
                      No address provided
                    </Alert>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Order Summary */}
        <Col lg={12} className="mb-4">
          <Card>
            <CardHeader>
              <h5 className="mb-0">Order Summary</h5>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md={4}>
                  <div className="mb-3">
                    <small className="text-muted">Subtotal</small>
                    <h4 className="mb-0">₹{order?.totals?.subtotal?.toLocaleString('en-IN', { maximumFractionDigits: 2 }) || '0.00'}</h4>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <small className="text-muted">Grand Total</small>
                    <h4 className="mb-0">₹{order?.grandTotal?.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</h4>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <small className="text-muted">Delivery Charges</small>
                    <h4 className="mb-0">₹{order?.deliveryCharge?.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</h4>
                  </div>
                </Col>
                {/* <Col md={3}>
                  <div className="mb-3">
                    <small className="text-muted">Payment Status</small>
                    <div>
                      <Badge color={getBadgeColor(order?.transaction?.status, 'payment')}>
                        {order?.transaction?.status?.toUpperCase() || 'N/A'}
                      </Badge>
                    </div>
                  </div>
                </Col> */}
              </Row>

              <Row className="mt-3">
                <Col md={4}>
                  <div className="mb-3">
                    <small className="text-muted">Order Date</small>
                    <p className="mb-0">{moment(order?.placedAt || order?.createdAt).format('DD/MM/YYYY hh:mm A')}</p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <small className="text-muted">Discount</small>
                    <p className="mb-0 text-success fw-bold">- ₹{order?.totals?.discount?.toLocaleString('en-IN', { maximumFractionDigits: 2 }) || '0.00'}</p>
                  </div>
                </Col>
                <Col md={6}>
                  {order?.coupon?.code && (
                    <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                      <small className="text-muted">Coupon Applied</small>
                      <div className="mt-2">
                        <Badge color="info" pill>{order?.coupon?.code}</Badge>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        {/* Products */}
        <Col lg={12} className="mb-4">
          <Card>
            <CardHeader>
              <h5 className="mb-0">Products ({order?.items?.length || 0})</h5>
            </CardHeader>
            <CardBody>
              <div className="table-responsive">
                <Table>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order?.items && order?.items?.length > 0 ? (
                      order?.items?.map((item, index) => (
                        <tr key={index}>
                          <td>
                            {item?.product ? (
                              <div className="d-flex align-items-center">
                                {item?.product?.images && (
                                  <img
                                    src={getPublicS3Url(Array.isArray(item?.product?.images) ? item?.product?.images[0] : item?.product?.images)}
                                    alt={item?.product?.name}
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      objectFit: 'cover',
                                      borderRadius: '6px',
                                      marginRight: '12px'
                                    }}
                                  />
                                )}
                                <div>
                                  <div>{item?.product?.name || 'Product'}</div>
                                  {item?.product?.isBestSeller && (
                                    <Badge color="warning" pill className="mt-1">Best Seller</Badge>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <span className="text-muted">Product details unavailable</span>
                            )}
                          </td>
                          <td>
                            ₹{item?.price?.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                          </td>
                          <td>{item?.quantity || 1}</td>
                          <td className="fw-bold">
                            ₹{((item?.price || 0) * (item?.quantity || 1))?.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted">
                          No products in this order
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SubOrder;